// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { SliderTokens } from './type';

const sliderTokens: SliderTokens = {
  sliderFontSize: 'Font-12',
  sliderTrackSize: 'Size-2',
  sliderTrackBackgroundColor: 'Neutral-fill-2',
  sliderTrackActiveBackgroundColor: 'Brand-6',
  sliderTrackDisabledBackgroundColor: 'Brand-3',
  sliderIndicatorSize: 'Size-6',
  sliderIndicatorBackgroundColor: 'Neutral-fill-1',
  sliderIndicatorBorderColor: 'Brand-6',
  sliderIndicatorBorderSize: 'Border-2',
  sliderIndicatorHoverBoderColor: 'Brand-5',
  sliderIndicatorActiveBackgroundColor: 'Brand-6',
  sliderIndicatorActiveShadow: 'Shadow-1',
  sliderIndicatorDisabledBorderColor: 'Brand-3',
  sliderIndicatorDisabledBackgroundColor: 'Neutral-fill-1',
  sliderValueBackgroundColor: 'Neutral-fill-1',
  sliderValueHoverBackgroundColor: 'Neutral-fill-9',
  sliderValueHoverFontColor: 'Neutral-text-1',
  sliderValueHoverRadius: 'Radius-lesser',
  sliderValueHoverPaddingX: 'Spacing-8',
  sliderValueHoverPaddingY: 'Spacing-3',
  sliderScaleLineSize: 'Size-3',
  sliderScaleLineBackgroundColor: 'Neutral-border-1',
  sliderScaleMarginY: 'Spacing-4',
  sliderScaleFontColor: 'Neutral-text-4',
  sliderScaleFontSize: 'Font-12',
};

export default sliderTokens;
